<template>
    <div class="order_history" v-if="info.allowGuestMode || (!info.allowGuestMode && member != null)">

        <div class="order_history_back_area display_responsive">
            <div class="back_btn_div" @click="orderPageGoBack()">
                <div class="back_btn"></div>
                <div class="back_text" v-if="!isDetailsClick">{{label['order_history_page_header_text']}}</div>
                <div class="back_btn no_icon"></div>
            </div>
        </div>

        <div class="order_history_area" :class="{order_details: isDetailsClick}">
            
            <div class="order_history_back_area display_desktop">
                <div class="back_btn_div" @click="orderPageGoBack()">
                    <div class="back_btn"></div>
                </div>
            </div>
            
            <transition name="fadeFast" mode="in-out">
                <div class="" style="width:100%;" v-if="!isDetailsClick">
                    <div class="order_history_title display_desktop">{{label['order_history_page_header_text']}}</div>

                    <!--
                    <div class="order_history_order_mode_tag_div">
                        <div class="order_mode_tag" :class="{active : orderMode == 'order'}" @click="changeOrderHistoryMode('order')">
                            <div class="order_mode_innertag">{{label['order_history_order_mode_text_order']}}</div>
                        </div>
                        <div class="order_mode_tag" :class="{active : orderMode == 'shopping'}" @click="changeOrderHistoryMode('shopping')">
                            <div class="order_mode_innertag">{{label['order_history_order_mode_text_shopping']}}</div>
                        </div>
                    </div>
                    -->

                    <div class="order_history_content_div" v-if="orderList != null && orderList.length > 0">

                        <div class="order_row"
                             v-for="(orderObj, index) in orderList"
                             :key="'o'+index">
                            <div class="order_row_div">

                                <div class="order_list_div">
                                    <div class="order_list_shop_image_area" @click="orderDataDetailsClick(orderObj)">
                                        <div class="shop_image_outer_div">
                                            <div class="shop_image_inner_div">
                                                <img loading="lazy" :src="orderObj.shopInfo.shopImage" :onerror="'this.onerror=null;this.src=\'/files/images/shop_image/default_shop.png\';'"  align="absmiddle" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="order_list_order_data_area" @click="orderDataDetailsClick(orderObj)">
                                        <div class="order_date_status_div">
                                            <div class="order_date_div">
                                                <div class="order_date_icon"></div>
                                                <div class="order_date">{{$root.orderDateTimeDisplay(orderObj.orderDate)}}</div>
                                            </div>
                                            <div class="order_status" :style="{'color':orderObj['statusColor']}">{{orderObj['statusText'+getItemSubfix()]}}</div>
                                        </div>
                                        <div class="order_shop_div">{{orderObj.shopInfo['name' + getItemSubfix()]}}</div>

                                        <div class="order_amount_number_div">
                                            <div class="order_amount_number">
                                                <div class="order_type_amount_div">
                                                    <div class="order_type" v-if="$root.CheckOrderOrderTypeIdx(orderObj) == 1">{{$root.GetOrderModePickupTypeLabel(1,orderObj.orderMode)}}．</div>
                                                    <div class="order_type" v-if="$root.CheckOrderOrderTypeIdx(orderObj) == 2">{{$root.GetOrderModePickupTypeLabel(2,orderObj.orderMode)}}．</div>
                                                    <div class="order_type" v-if="$root.CheckOrderOrderTypeIdx(orderObj) == 3">{{$root.GetOrderModePickupTypeLabel(3,orderObj.orderMode)}}．</div>
                                                    <div class="order_amount">
                                                        {{label['order_history_order_data_text_amount_total']}}
                                                        <money :price="orderObj.amount" />
                                                    </div>
                                                </div>
                                                <!--<div class="order_no_div">#{{orderObj.orderNo}}</div>--> <!-- change to pickUpNo for tenren -->
                                                <div class="order_no_div">#{{orderObj.pickUpNo}}</div>
                                            </div>
                                            <div class="order_amount_number_btn">
                                                <div class="order_list_div_btn_fix" @click="orderDataDetailsItemsReOrder(orderObj)">
                                                    {{label['reorder.text']}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="order_list_btn_area">
                                        <div class="order_details_btn" @click="orderDataDetailsClick(orderObj)">
                                            {{label['order_history_order_data_text_order_details']}}
                                        </div>

                                        <div class="order_details_btn" @click="orderDataDetailsItemsReOrder(orderObj)">
                                            {{label['reorder.text']}}
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <!-- order_row_div -->

                        </div>
                        <!-- order_row -->

                    </div>
                    <!-- order_history_content_div have history -->

                    <div class="order_history_content_div" v-if="orderList == null || orderList.length <= 0">
                        {{label['order_history_page_no_order_history_text']}}
                    </div>
                    <!-- order_history_content_div no history -->
                </div>
            </transition>
            <!-- isDetailsClick == false -->


            <transition name="fadeFast" mode="out-in">
                <router-view class="order_data_details"></router-view>
            </transition>
            <!-- isDetailsClick == true -->

        </div>

    </div>
</template>

<script>

    export default {
        data() {
            return {
                orderMode:"order",
                is_openOrder: false,
                orderList:null,
                isDetailsClick: false,
                orderStatusList: [],
                payMethodList:[],

                orderNo: undefined,
            };
        },
        computed: {
            info() {
                return this.$root.info;
            },
            label() {
                return this.$root.getLabel();
            },
            cart() {
                return this.$root.cart;
            },
            member() {
                return this.$root.cart.member;
            },
        },
        components: {},
        created() {
            this.orderNo = this.$route.params.orderNo;

            this.info.loading = false;           
            this.$root.getCurrentPathName();

            if (!this.info.allowGuestMode) {
                if (this.member == null) {
                    this.$root.page_after_login = this.info.currentPathName;
                    this.$router.replace("/guestlogin");
                }
            }

            // get member order history
            if (this.orderList == null) {
                this.GetPayMethodList();
                this.GetOrderStatusList();
                this.GetMemberOrderList();
            }

            console.log("app.orderList", this.orderList);
        },
        methods: {
            getItemSubfix() {
                return this.$root.getItemSubfix();
            },   
            getShopImage(shop) {
                return this.$root.getShopImage(shop);
            },

            changeOrderHistoryMode(mode) {
                this.orderMode = mode;
            },

            orderPageGoBack() {
                console.log("this.orderNo", this.orderNo);
                if (this.isDetailsClick) {
                    this.$router.replace("/member/orderhistory");                   
                }
                else {
                    this.$router.replace("/");
                }
            },

            GetPayMethodList() {                
                $.get(
                    "/files/payMethod.json",
                    data => {
                        this.payMethodList = data.list;
                    },
                    "JSON"
                );            
            },
            GetPayMethodName(payMethod) {                
                var temp_data = this.payMethodList.filter(m => m.code == payMethod.code);
                if (temp_data.length > 0) {
                    return temp_data[0]['name' + this.getItemSubfix()];
                }
                else {
                    return payMethod.code;
                }
            },

            GetOrderStatusList() {
                /*
                $.get(
                    "/files/order_status.json",
                    data => {
                        console.log("GetOrderStatusList",data);
                        this.orderStatusList = data.list;
                    },
                    "JSON"
                );
                */
                this.$root.wsGetAsync(
                    "/files/order_status.json",
                    this.lang,
                    data => {
                        //console.log("GetOrderStatusList", data);
                        this.orderStatusList = data.list;
                    }
                );                
            },

            GetMemberOrderList() {
                var app = this;
                app.info.loading = true;
                if (app.cart.token != "" && app.cart.member != null) {
                    app.$root.wsGet(
                        app.info.wsUrl + "/Order/GetOrderHistory?token=" + encodeURIComponent(app.cart.token),
                        app.lang,
                        data => {
                            console.log("GetMemberOrderList", data);

                            if (data.status == 0) {
                                app.orderList = data.orders;
                                app.mapOrderInfo();
                            }
                            else {
                                app.$root.alert(data.message);
                            }

                            app.info.loading = false;
                        }
                    );
                }
                else {
                    if (this.info.allowGuestMode) {
                        app.orderList = JSON.parse(window.localStorage.getItem("orders") || "[]");
                        app.mapOrderInfo();
                    }
                    app.info.loading = false;
                }
            },
            mapOrderInfo() {
                var app = this;
                var temp_shop = null;
                var temp_status = null;
                $.each(app.orderList, (i, o) => {
                    temp_shop = app.$root.getShopInfo(o.shop.shopCode);
                    o.shopInfo = (temp_shop == null || temp_shop == undefined) ? o.shop : temp_shop;
                    //o.shopInfo.shopImage = app.$root.getShopImageCheck(o.shopInfo);
                    o.shopInfo.shopImage = app.$root.getShopImage(o.shopInfo);
                    if (o.shopInfo.shopImage == "") {
                        o.shopInfo.shopImage = "/files/images/shop_image/default_shop.png";
                    }

                    temp_status = this.orderStatusObj(o);
                    if (temp_status != null) {
                        o.statusColor = temp_status.color;
                        o.statusText1 = temp_status['name1'];
                        o.statusText2 = temp_status['name2'];
                        o.statusText3 = temp_status['name3'];
                        o.statusBarWidth = temp_status['statusBarWidth'];
                        o.showQROrderCode = temp_status['showQROrderCode'];
                    }
                    else {
                        o.statusColor = this.label['order_history_order_data_status_default_color'];
                        o.statusText1 = this.label['order_history_order_data_status_default_text'];
                        o.statusText2 = this.label['order_history_order_data_status_default_text'];
                        o.statusText3 = this.label['order_history_order_data_status_default_text'];
                        o.statusBarWidth = 0;
                        o.showQROrderCode = false;
                    }
                });
            },
            orderItemsCount(orderObj, not_in_arr) {
                if (not_in_arr == undefined) not_in_arr = [];
                var c = 0;
                orderObj.items.forEach(i => {
                    if (!not_in_arr.includes(i.id)) {
                        if (i.qty > 0) c += i.qty;
                    }
                });
                return c;
            },
            orderStatusColor(orderObj) {
                var status_data = this.orderStatusList.filter(s => (s.status == orderObj.status && s.zeekStatus == orderObj.zeekStatus));
                if (status_data.length > 0) {
                    return status_data[0].color;
                }
                else {
                    return this.label['order_history_order_data_status_default_color'];
                }
            },
            orderStatusText(orderObj) {
                var status_data = this.orderStatusList.filter(s => (s.status == orderObj.status && s.zeekStatus == orderObj.zeekStatus));
                if (status_data.length > 0) {
                    return status_data[0]['name' + this.getItemSubfix()];
                }
                else {
                    return this.label['order_history_order_data_status_default_text'];
                }
            },
            orderStatusObj(orderObj) {
                var status_data = null;

                if (orderObj.zeekStatus != undefined && orderObj.zeekStatus != null && orderObj.zeekStatus != "") {
                    status_data = this.orderStatusList.filter(s => (s.zeekStatus == orderObj.zeekStatus));
                }

                if (status_data != null && status_data.length > 0) {
                    return status_data[0];
                }
                else {
                    status_data = this.orderStatusList.filter(s => (s.status == orderObj.status));

                    if (status_data.length > 0) {
                        return status_data[0];
                    }
                    else {
                        return null;
                    }
                }
            },

            orderDataDetailsClick(orderObj) {
                //console.log("orderObj", orderObj);
                this.isDetailsClick = true;
                this.$router.push("/member/orderhistory/" + orderObj.orderNo);
            },

            orderDataDetailsItemsReOrder(orderObj) {
                console.log("orderObj", orderObj);

                this.$root.reorder_temp_data.shop = JSON.parse(JSON.stringify(orderObj.shop));
                this.$root.reorder_temp_data.items = JSON.parse(JSON.stringify(orderObj.items));
                //this.$root.alert(this.label['reorder.text.isCopy']);
                this.$router.push("/");
            },


        },
    };
</script>
